import _get from 'lodash/get';
import config from '@bedrock-rdk/config';
import { appVersion } from '@bedrock-rdk/utils';
import engine from '@bedrock/fido-sdk/es/services/thirdParty/engines/newrelic.engine';

export const engineName = 'newrelic';

export const getEngine = () => {
  const { analytics } = config;

  return {
    thirdPartyServiceConfig: {
      key: engineName,
      name: engineName,
      // NOTE: use it as a plug since engine throws the error "TypeError: boot is not a function".
      // The boot script injects in the runtime using HtmlWebpackPlugin to be able to catch on loading errors
      bootMethod: () => ({}),
      engine: () => engine,
      initParams: {
        events: _get(analytics, `taggingPlans.${engineName}`, {}),
        attributesKeysMapping: _get(analytics, `attributesKeysMapping.${engineName}`, {}),
        version: appVersion,
      },
    },
  };
};
